import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { BehaviorSubject, Observable, catchError, throwError } from 'rxjs';
// Model
import { ORIGIN, OriginSourceData } from '../models/partial-integration.model';
// Service
import { MiMutualService } from '../../service/mi-mutual.service';
import { RelianceFirstService } from '../../service/reliance-first.service';

@Injectable()
export class PartialIntegrationService {
	private reloadListSubject = new BehaviorSubject({});
	private reloadListListener = this.reloadListSubject.asObservable();

	constructor(
		private miMutualSevice: MiMutualService,
		private relianceFirstService: RelianceFirstService
	) { }

	/**
	 * Generic method for making HTTP GET requests.
	 * @param origin @see ORIGIN
	 * @param params Query parameters.
	 */
	getData(origin: ORIGIN, params: any): Observable<any> {
		let httpParams = new HttpParams();
		let serviceData;

		// Convert filter object to HttpParams
		Object.keys(params).forEach(key => {
			if (params[key]) {
				httpParams = httpParams.append(key, params[key]);
			}
		});

		switch(origin) {
			case ORIGIN.MI_MUTUAL:
				serviceData = this.miMutualSevice.getData(httpParams);
				break;
			case ORIGIN.RELIANCE_FIRST:
				serviceData = this.relianceFirstService.getData(httpParams);
				break;
		}

		return serviceData.pipe(
			catchError(error => {
				// Handle error here
				return throwError(error);
			})
		);
	}


	/**
	 * Method for getting order details from the MI Mutual service.
	 * @param id Loan || id depends of the endpoint number.
	 */
	getOrderDetails(id: string, origin: ORIGIN): Observable<any> {
		let serviceData;

		switch(origin) {
			case ORIGIN.MI_MUTUAL:
				serviceData = this.miMutualSevice.getOrderDetails(id);
				break;
			case ORIGIN.RELIANCE_FIRST:
				serviceData = this.relianceFirstService.getOrderDetails(id);
				break;
		}

		return serviceData;
	}
	
	/**
	 * Sets a new value for the reload list listener
	 * @param reload = true for reloading otherwise doesn't reload the list.
	 */
	reloadList(dataSet: OriginSourceData): void {
		this.reloadListSubject.next(dataSet);
	}

	/**
	 * Returns the reload-list listener
	 */
	getReloadListListener(): Observable<any> {
		return this.reloadListListener;
	}
}
